export const DEFAULT_THEME = "light";